import { Component, defineComponent, h, inject, provide } from 'vue'
import { data } from '../posts.data'
import { CategoryTag, Posts } from '../types/post'

export const postsSymbol = Symbol('postsSymbol')
export const categoriesSymbol = Symbol('categoriesSymbol')
export const tagsSymbol = Symbol('tagsSymbol')



export function withDataProvider(App: Component) {
  return defineComponent({
    name: 'VDataProvider',
    setup(_, { slots }) {
      const { posts, categories, tags } = data

      provide(postsSymbol, posts)
      provide(categoriesSymbol, categories)
      provide(tagsSymbol, tags)


      return () => h(App, null, slots)
    }
  })
}


export function usePosts(): Posts {
  return inject(postsSymbol) || []
}

export function useCategories(): CategoryTag {
  return inject(categoriesSymbol) || {}
}

export function useTags(): CategoryTag {
  return inject(tagsSymbol) || {}
}
